// extracted by mini-css-extract-plugin
module.exports = {"hidden":"StripeExpress_hidden__rNSox"};